import React from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';

import { RMWContext } from 'app/shared/providers/RMWContext';

import billingUtils from 'app/shared/utils/billingUtils';

import BillingActions from 'app/shared/actions/BillingActions';

// components
import PermissionCheck from 'app/shared/components/PermissionCheck';
import HeadWrapper from 'app/shared/components/HeadWrapper';
import TableMFH from 'app/shared/components/TableMFH';

// containers
import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';

// constants
import { INVOICE_PAYMENTS } from 'app/shared/constants/RouteConstants';
import LoadingConstants from 'app/shared/constants/LoadingConstants';

import {
    Text,
    TextButton,
} from '@zillow/constellation';

const PaymentSettingsPage = () => {
    const dispatch = useDispatch();
    const accountSettings = useSelector(state => state.billing.paymentMethods.accountSettings);
    const loadingState = useSelector(state => state.billing.paymentMethods.loadingState);

    const { paths } = React.useContext(RMWContext);
    React.useEffect(() => {
        dispatch(BillingActions.getPaymentMethodsForUser());
        dispatch(BillingActions.getAccountPaymentSettingsForUser());
        return () => dispatch(BillingActions.paymentMethodsInit());
    }, []);

    const handleEditClick = (accountNumber) => {
        window.router.transitionTo(`${paths.billingPage}/account/${accountNumber}?prev=settings`);
    };

    const renderPaymentMethod = paymentMethod => (
        <React.Fragment>
            <Text>
                {billingUtils.formatPaymentMethod(paymentMethod)}
            </Text>
            {paymentMethod.paymentType === 'CreditCard' && (
                <>
                    <br />
                    <Text>
                        {`Expires ${paymentMethod.expirationMonth}/${paymentMethod.expirationYear}`}
                    </Text>
                </>
            )}
        </React.Fragment>
    );

    const columnConfig = [
        {
            width: 3,
            header: 'Account',
            renderer: account => account.accountName,
            align: 'left',
        },
        {
            width: 2,
            header: 'Next Payment Date',
            renderer: account => (account.autopay ? billingUtils.getNextAutoPaymentDate() : '-'),
            align: 'left',
        },
        {
            width: 2,
            header: 'Payment Method',
            renderer: (account) => {
                if (!account.autopayMethod || !account.autopay) {
                    return '-';
                }
                return renderPaymentMethod(account.autopayMethod);
            },
            align: 'left',
        },
        {
            width: 2,
            header: 'Auto Pay',
            renderer: account => (account.autopay ? 'ON' : 'OFF'),
            align: 'left',
        },
        {
            width: 1,
            header: '',
            renderer: account => (
                <TextButton onClick={() => handleEditClick(account.accountNumber)}>Edit</TextButton>
            ),
            align: 'center',
        },
    ];

    return (
        <AuthCheckWrapper requireStrongAuthentication={false}>
            <PermissionCheck route={INVOICE_PAYMENTS}>
                <div className="PaymentSettingsPage">
                    <HeadWrapper title="Payment Settings" />
                    <TableMFH
                        columnConfig={columnConfig}
                        data={accountSettings}
                        isLoading={loadingState === LoadingConstants.LOADING}
                        edgePadding={14}
                    />
                </div>
            </PermissionCheck>
        </AuthCheckWrapper>
    );
};

export default connect()(PaymentSettingsPage);
